module.exports = __webpack_public_path__ + "static/media/wireless_comm.82e60361.jpeg";